import React, { useEffect, useState } from 'react';
import { IQuestionListItem, ISubmitClozeAnswer } from '@/types';
import './index.less';
import { Input, Select } from 'antd';
import classNames from 'classnames';
import { ClozeSelectIcon } from '@/svgs';
import { useRequest } from 'ahooks';

interface IProps {
    questionItem: IQuestionListItem;
    onChangeQuestion: (val: ISubmitClozeAnswer[]) => void;
}

const ClozeTest = (props: IProps) => {
    const { questionItem, onChangeQuestion } = props;
    const { questionSeaClozeContent } = questionItem;

    const [userMap, setUserMap] = useState<{ [key: string]: string }>({}); // 用户答案

    const { run: dealyRunChange } = useRequest(
        (params: { key: string; rightAnswer: string; userAnswer: string }[]) => {
            return new Promise(resolve => {
                resolve(onChangeQuestion?.(params));
            });
        },
        {
            debounceWait: 800,
            manual: true,
        }
    );

    const onChangeCloze = (params: { key: string; rightAnswer: string; userAnswer: string }) => {
        const currentUserMap = {
            ...userMap,
            [params.key]: params.userAnswer,
        };
        setUserMap(currentUserMap);
        const clozeUserAnswerList = Object.entries(currentUserMap).map(([key, value]) => ({
            key,
            rightAnswer: '',
            userAnswer: value,
        }));
        dealyRunChange(clozeUserAnswerList);
    };

    // 初始化
    useEffect(() => {
        const userClozeAnswers = questionItem.userAnswer?.userClozeAnswers || [];
        const currentUserMap: { [key: string]: string } = {};

        userClozeAnswers.forEach(item => {
            currentUserMap[item.key] = item.userAnswer;
        });
        setUserMap(currentUserMap);
    }, [questionItem]);

    const retureCloze = (item: IQuestionListItem['questionSeaClozeContent'][number]) => {
        switch (item.type) {
            case 'picture':
                return <img style={{ maxWidth: '100%', verticalAlign: 'middle', margin: 2, borderRadius: 4 }} src={item.picture.link} />;
            case 'text':
                return <span dangerouslySetInnerHTML={{ __html: item.content }} />;
            case 'input':
                return (
                    <Input
                        placeholder="请输入"
                        value={userMap[item.key]}
                        onChange={e =>
                            onChangeCloze({
                                key: item.key,
                                rightAnswer: item.inputQuestion.rightAnswer,
                                userAnswer: e.target.value,
                            })
                        }
                    />
                );
            case 'select':
                return (
                    <Select
                        placeholder="请选择"
                        value={userMap[item.key]}
                        popupMatchSelectWidth={343}
                        popupClassName="sub-tiku__select-cloze-item"
                        onChange={val =>
                            onChangeCloze({
                                key: item.key,
                                rightAnswer: item.selectList.rightAnswer,
                                userAnswer: val,
                            })
                        }
                    >
                        {item.selectList?.options.map(child => (
                            <Select.Option key={child.value} value={child.value}>
                                {child.label}
                            </Select.Option>
                        ))}
                    </Select>
                );
            case 'radioTable':
                return (
                    <div className="sub-tiku__cloze-radio-tabel-box">
                        <div className="sub-tiku__radio-table-item">
                            <div />
                            {item.radioTableInfo?.dataList.map(child => (
                                <div
                                    className="sub-tiku__radio-table-option"
                                    key={child.key}
                                    dangerouslySetInnerHTML={{ __html: child.label }}
                                />
                            ))}
                        </div>
                        {item.radioTableInfo?.questionListInfo.map(child => {
                            const optionNum = item.radioTableInfo?.dataList.length;
                            const opitonList = Array(optionNum)
                                .fill(0)
                                .map((_, index) => index);
                            return (
                                <div key={child.key} className="sub-tiku__radio-table-item">
                                    <div dangerouslySetInnerHTML={{ __html: child.title.replace('&nbsp;', '') }} />
                                    {opitonList.map(son => {
                                        const isUserChecked = userMap[child.key] === String.fromCharCode(son + 65);
                                        return (
                                            <div className="sub-tiku__single-radio--box" key={String.fromCharCode(son + 65)}>
                                                <div
                                                    onClick={() =>
                                                        onChangeCloze({
                                                            key: child.key,
                                                            rightAnswer: child.rightAnswer,
                                                            userAnswer: String.fromCharCode(son + 65),
                                                        })
                                                    }
                                                    className={classNames('sub-tiku__single-radio-option-item', {
                                                        'sub-tiku__user-checked': isUserChecked,
                                                    })}
                                                >
                                                    {isUserChecked && <ClozeSelectIcon />}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                );
            case 'table':
                return (
                    <div className="sub-tiku__cloze-tabel-box" style={{ width: (item.tableInfo?.width || 200) * item.tableInfo!.col }}>
                        {item.tableInfo!.tableList.map(child => (
                            <div
                                key={child.key}
                                className="sub-tiku__cloze-tabel-item"
                                style={{ flexBasis: `${100 / item.tableInfo!.col}%` }}
                            >
                                {child.childList.map(son => (
                                    <span key={son.key}>
                                        {son.type === 'text' && <span dangerouslySetInnerHTML={{ __html: son.content || '' }} />}
                                        {son.type === 'input' && (
                                            <Input
                                                placeholder="请输入"
                                                value={userMap[son.key]}
                                                onChange={e =>
                                                    onChangeCloze({
                                                        key: son.key,
                                                        rightAnswer: son.inputQuestion.rightAnswer,
                                                        userAnswer: e.target.value,
                                                    })
                                                }
                                            />
                                        )}
                                        {son.type === 'select' && (
                                            <Select
                                                placeholder="请选择"
                                                value={userMap[son.key]}
                                                popupMatchSelectWidth={343}
                                                popupClassName="sub-tiku__select-cloze-item"
                                                onChange={val =>
                                                    onChangeCloze({
                                                        key: son.key,
                                                        rightAnswer: son.selectList.rightAnswer,
                                                        userAnswer: val,
                                                    })
                                                }
                                            >
                                                {son.selectList?.options.map(child => (
                                                    <Select.Option key={child.value} value={child.value}>
                                                        {child.label}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        )}
                                    </span>
                                ))}
                            </div>
                        ))}
                    </div>
                );
            default:
                break;
        }
    };
    return (
        <div className="sub-tiku__coze-title-view sub-tiku__do-cloze-view">
            {questionSeaClozeContent.map(item => {
                return <React.Fragment key={item.key}>{retureCloze(item)}</React.Fragment>;
            })}
        </div>
    );
};

export default ClozeTest;
